import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-6 help",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    },
    attrs: {
      "justify": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$i18n_t('Common.helpHead')))]), _c('p', {
    staticClass: "headinfo"
  }, [_vm._v("Finde hier verschiedene Resourcen rund um die Benutzung der Plattform.")]), _c(VExpansionPanels, {
    staticClass: "mt-4",
    model: {
      value: _vm.helpPanels,
      callback: function ($$v) {
        _vm.helpPanels = $$v;
      },
      expression: "helpPanels"
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, {
    staticClass: "py-6"
  }, [_c('div', [_vm._v("Allgemeine Hilfe")])]), _c(VExpansionPanelContent, [_c(VExpansionPanels, {
    staticClass: "inner",
    attrs: {
      "accordion": ""
    }
  }, _vm._l(_vm.generalQuestionsWithPermission, function (question, i) {
    return _c(VExpansionPanel, {
      key: `general_question_${i}`
    }, [_c(VExpansionPanelHeader, {
      staticClass: "px-4 py-0"
    }, [_c('span', [_vm._v(_vm._s(question.q))])]), _c(VExpansionPanelContent, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(question.a)
      }
    })])], 1);
  }), 1)], 1)], 1), _c(VExpansionPanel, [_c(VExpansionPanelHeader, {
    staticClass: "py-6"
  }, [_c('div', [_vm._v("Anleitungsvideos")])]), _c(VExpansionPanelContent, [_c(VExpansionPanels, {
    staticClass: "inner",
    attrs: {
      "accordion": ""
    }
  }, _vm._l(_vm.videosWithPermission, function (video, i) {
    return _c(VExpansionPanel, {
      key: `video_${i}`
    }, [_c(VExpansionPanelHeader, {
      staticClass: "px-4 py-0"
    }, [_c('span', [_vm._v(_vm._s(video.title))])]), _c(VExpansionPanelContent, [_c('iframe', {
      staticClass: "youtube_video",
      attrs: {
        "src": `https://www.youtube.com/embed/${video.youtube}`,
        "frameborder": "0",
        "allow": "encrypted-media; picture-in-picture",
        "allowfullscreen": ""
      }
    })])], 1);
  }), 1)], 1)], 1), _c(VExpansionPanel, [_c(VExpansionPanelHeader, {
    staticClass: "py-6"
  }, [_c('div', [_vm._v("Häufige Fragen")])]), _c(VExpansionPanelContent, _vm._l(_vm.faqQuestionsWithPermission, function (section) {
    return _c('div', {
      key: `section_${section.title}`
    }, [_c('h4', [_vm._v(_vm._s(section.title))]), _c(VRow, [_c(VExpansionPanels, {
      staticClass: "inner",
      attrs: {
        "accordion": ""
      }
    }, _vm._l(section.questions, function (question, i) {
      return _c(VExpansionPanel, {
        key: `section_${section.title}_question_${i}`
      }, [_c(VExpansionPanelHeader, {
        staticClass: "px-4 py-0"
      }, [_c('span', [_vm._v(_vm._s(question.q))])]), _c(VExpansionPanelContent, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(question.a)
        }
      })])], 1);
    }), 1)], 1)], 1);
  }), 0)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };